import "./NavBar.scss"
import { PcMenu } from "../../molecules/PcMenu/PcMenu";
import { Link } from "react-router-dom";
import { MovilMenu } from "../../molecules/MovileMenu/MovileMenu";
import { BurguerButton } from "../../atoms/BurguerButton/BurguerButton";
import { OptimizedImage } from "../../atoms/OptimizedImage/OptimizedImage";
import React, { useState } from "react";

export const NavBar = ({setIsLogin}) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };
    const closeMenu = () => {
        setIsOpen(false);
    };
    return (
        <header>
            <div className="container-menu">
                <Link className="brand-menu" to={"/"}>
                    <OptimizedImage className="brand" alt="Shofi" src="/images/brands/logo-shofi.png" priority width={140} height={100} />
                </Link>
                <section className="menu">
                    <PcMenu
                    setIsLogin={setIsLogin} 
                    />
                    <BurguerButton 
                    toggleMenu = {toggleMenu} 
                    isOpen = {isOpen}
                    />
                </section>
            </div>
            <MovilMenu 
                setIsLogin={setIsLogin}
                closeMenu = {closeMenu}
                isOpen ={isOpen}
                setIsOpen={setIsOpen}
            />
        </header>
    );
}
